import { render, staticRenderFns } from "./trombi.vue?vue&type=template&id=17732212&scoped=true"
import script from "./trombi.vue?vue&type=script&lang=js"
export * from "./trombi.vue?vue&type=script&lang=js"
import style0 from "./trombi.vue?vue&type=style&index=0&id=17732212&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17732212",
  null
  
)

export default component.exports